import cx from 'clsx';
import {
  Badge as MBadge,
  rem,
  type BadgeCssVariables,
  type BadgeProps,
  type MantineSize,
} from '@mantine/core';
import classes from './badge.module.scss';

const defaultProps: Partial<BadgeProps> = {
  variant: 'light',
  color: 'white-done',
  size: 'xs',
};

const badgeStyles: Record<
  MantineSize | string,
  Partial<Record<BadgeCssVariables['root'], string>>
> = {
  xs: {
    '--badge-height': rem(26),
    '--badge-padding-x': rem(8),
  },
  sm: {
    '--badge-height': rem(36),
    '--badge-padding-x': rem(12),
  },
  md: {
    '--badge-height': rem(38),
    '--badge-padding-x': rem(13),
  },
  lg: {
    '--badge-height': rem(48),
    '--badge-padding-x': rem(16),
  },
  xl: {
    '--badge-height': rem(56),
    '--badge-padding-x': rem(18),
  },
};

export const Badge = MBadge.extend({
  defaultProps,
  classNames: (_theme, props) => ({
    root: cx(classes.root, {
      [classes[props.color || defaultProps.color!]]: true,
    }),
    label: classes.label,
  }),
  vars: (_theme, props) => ({
    root: {
      '--badge-radius': rem(8),
      ...(badgeStyles[props.size || defaultProps.size!] ?? {}),
    },
  }),
});

Badge.defaultProps = {
  variant: 'light',
};
